import { createHttpLink } from "@apollo/client";
import { NEXT_PUBLIC_API_BASE_URL } from "../../client";

const httpLink = createHttpLink({
  uri: `${NEXT_PUBLIC_API_BASE_URL}/graphql`,
  credentials: "include",
});

export default httpLink;
